import { create, UseBoundStore } from 'zustand';

import _ from 'scbk-services/utils/lodash-extension.ts';

import type { RestRequest } from 'scbk-services/types/http/rest-request';
import type { StoreApi } from 'zustand';

interface RestHeaderState {
    restRequestHeader: RestRequest.Header;
    getRestRequestHeader: () => RestRequest.Header;
    resetRestRequestHeader: () => void;
    setRestRequestHeader: (header: RestRequest.Header) => void;
    updateRestRequestHeader: (header: RestRequest.Header) => void;
    getXAuthToekn: () => string;
}

let storeInstance: UseBoundStore<StoreApi<RestHeaderState>> | null = null;

const createStore = () =>
    create<RestHeaderState>((set, get) => ({
        restRequestHeader: {},

        getRestRequestHeader: () => get().restRequestHeader,

        resetRestRequestHeader: () => set({ restRequestHeader: {} }),

        setRestRequestHeader: (header: RestRequest.Header) => set({ restRequestHeader: header }),

        updateRestRequestHeader: (header: RestRequest.Header) =>
            set((state) => ({ restRequestHeader: { ...state.restRequestHeader, ...header } })),

        getXAuthToekn: () => get().restRequestHeader['x-auth-token'] || '',
    }));

const useRestHeaderStore = (() => {
    if (_.isEmpty(storeInstance)) {
        storeInstance = createStore();
    }

    return storeInstance!;
})();

export { useRestHeaderStore };
